import { FC, SVGProps } from 'react'

interface MessageIconProps extends SVGProps<SVGSVGElement> {
  size?: number
}

const MessageIcon: FC = ({ size = 16, ...props }: MessageIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.4994 3H3.49991C2.67262 3 2 3.67262 2 4.49991V11.2495C2 12.0768 2.67262 12.7494 3.49991 12.7494H5.74978V14.7181C5.74978 14.9477 6.01227 15.0813 6.19741 14.9454L9.12458 12.7494H12.4994C13.3267 12.7494 13.9993 12.0768 13.9993 11.2495V4.49991C13.9993 3.67262 13.3267 3 12.4994 3Z"
        fill="white"
      />
    </svg>
  )
}

export default MessageIcon
